import { useEffect } from 'react';

/**
 * Custom hook to force dark mode for all users
 * @returns {Object} Theme state (always dark mode)
 */
export const useThemeMode = () => {
  // Always force dark mode
  const isLightMode = false;

  // Apply dark theme on mount and ensure it stays
  useEffect(() => {
    // Force dark mode
    document.documentElement.classList.add("dark");

    // Remove any light mode remnants
    document.documentElement.classList.remove("light");

    // Set localStorage to dark (optional, for consistency)
    localStorage.setItem("theme", "dark");

    // Remove any existing light theme preference
    if (localStorage.getItem("theme") === "light") {
      localStorage.setItem("theme", "dark");
    }
  }, []);

  // Disabled toggle function (returns nothing to prevent toggling)
  const toggleModeChange = () => {
    // Do nothing - theme is locked to dark mode
    console.log("Theme is locked to dark mode");
  };

  return {
    isLightMode,
    toggleModeChange // Keep for compatibility, but it won't do anything
  };
};